import { useRef, useEffect, useState, useMemo } from "react";

import { searchTracks } from "../../store/thunks/reports/downloadThunk";

import Table from "../../components/Table/Table";

const columns = [
	{ title: "ID", dataIndex: "_id", key: "_id", minWidth: "120px" },
	{
		title: "Track Title",
		dataIndex: "trackTitle",
		key: "trackTitle",
		minWidth: "200px",
	},
	{
		title: "Version Type",
		dataIndex: "versionType",
		key: "versionType",
		minWidth: "120px",
	},
	{
		title: "Artist(s)",
		dataIndex: "artists",
		key: "artists",
		minWidth: "150px",
	},
	{
		title: "Remixer(s)",
		dataIndex: "remixer",
		key: "remixers",
		minWidth: "150px",
	},
	{
		title: "Downloads",
		dataIndex: "downloads",
		key: "downloads",
		minWidth: "100px",
	},
];

const DownloadsTable = ({ filters }) => {
	const pageSetterRef = useRef(null);
	const [refreshTrigger, setRefreshTrigger] = useState(0); // Add refresh trigger state
	
	// Effect to trigger refresh when filters change
	useEffect(() => {
		setRefreshTrigger(prev => prev + 1);
		// If we have a page setter ref from Table component, call it to reset the page
		if (pageSetterRef.current) {
			pageSetterRef.current(1);
		}
	}, [filters]);

	// Create a custom row key function that combines multiple properties to ensure uniqueness
	const getRowKey = (record) => {
		return `${record._id}_${record.versionType}_${record.remixer || ""}_${
			record.trackTitle
		}`;
	};

	return (
		<Table
			columns={columns}
			fetchData={searchTracks}
			refreshTrigger={refreshTrigger} // Use the refresh trigger state
			rowKey={getRowKey} // Use the custom row key function
			dataKey="items"
			headingBgColor="#0D141B"
			headingTextColor="#FFFFFF"
			initialPageSize={25}
			setPageCallback={(fn) => (pageSetterRef.current = fn)}
			customQueryParams={(params) => ({
				...params,
				search: filters?.search || "",
				startDate: filters?.startDate || "",
				endDate: filters?.endDate || "",
			})}
		/>
	);
};

export default DownloadsTable;